import Validator from './validator.js';

export default class AtLeastOneCheckedValidator extends Validator {
    constructor(input) {
        super(input);
        this.type = this.input.el.type;
        this.field = this.input.parent;
    }

    valid() {
        return Promise.resolve(this.field.inputs.filter(i => i.el.type === 'checkbox').some(i => i.el.checked));        
    }

    static applies(input) {
        return input.el.dataset.atLeastOneChecked !== undefined;
    }
}
